import React, { ReactNode } from 'react'
import { createPortal } from 'react-dom'

import clsx from 'clsx'

interface Props {
  children: ReactNode
  onClose?: () => void
  className?: string
  style?: React.CSSProperties
}

/**
 * Findee 画面のモーダルの暗幕。`document.body` 直下へ portal で描画する（SMART_HUB_DEV-142）。
 *
 * 共通レイアウト（Main.tsx）の本文枠が `relative z-1` で重なり順の文脈を作るため、その中に
 * 置いたモーダルは `z-modal` を付けても固定ヘッダー（z-header）より下に描かれ、上端がヘッダー裏に
 * 隠れていた。暗幕もヘッダーの下になり、モーダル表示中にヘッダーが操作できた。
 * 共通部品の DisclosureWrapper と同じく body へ出して、本文枠の文脈から外す。
 *
 * 中身が画面より高いときは暗幕ごとスクロールさせる（上端が切れて届かない状態を作らない）。
 */
export default function ModalOverlay({ children, onClose, className, style }: Props) {
  return createPortal(
    <div onClick={onClose} className={clsx('overflow-y-auto', className)} style={style}>
      {children}
    </div>,
    document.body
  )
}
